/**
 * In-card colour switcher.
 * Each swatch links to a sibling colour product. Clicking swaps the card's
 * image, price and the product/variant references in place — no navigation.
 * Plain links remain as a no-JS fallback.
 */
if (!customElements.get('card-color-swatches')) {
    customElements.define('card-color-swatches', class CardColorSwatches extends HTMLElement {
        connectedCallback() {
            this.card = this.closest('.product-card');
            // Swatches live inside the image link, so stop the click from
            // bubbling up to the product link.
            this.swatches = Array.from(this.querySelectorAll('.product-card-swatch[data-variant]'));
            this.swatches.forEach((sw) => {
                sw.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.select(sw);
                });
                sw.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.stopPropagation();
                        this.select(sw);
                    }
                });
            });
            // "+N" chip navigates to the product page (same as "Les mer").
            const more = this.querySelector('.product-card-swatch._more[data-go]');
            if (more) {
                more.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = more.dataset.go;
                });
            }
        }

        select(sw) {
            if (!this.card) return;

            this.querySelectorAll('.product-card-swatch').forEach((s) => s.classList.remove('active'));
            sw.classList.add('active');

            const url = sw.dataset.url;

            // Front image (+ <source> srcset)
            if (sw.dataset.image) {
                const picture = this.card.querySelector('.product-card-picture._front');
                if (picture) {
                    const img = picture.querySelector('img');
                    if (img) {
                        img.src = sw.dataset.image;
                        img.srcset = sw.dataset.image;
                    }
                    picture.querySelectorAll('source').forEach((source) => {
                        source.srcset = sw.dataset.image;
                    });
                }
            }

            // Links (image, title, "Les mer")
            this.card.querySelectorAll('a.product-card-top, a.product-card-body-inner, a.product-card-link').forEach((a) => {
                a.setAttribute('href', url);
            });

            // Title
            if (sw.dataset.title) {
                const titleEl = this.card.querySelector('.product-card-title');
                if (titleEl) titleEl.textContent = sw.dataset.title;
            }

            // Price
            const current = this.card.querySelector('.product-card-price-current');
            if (current && sw.dataset.price) current.textContent = sw.dataset.price;
            const oldEl = this.card.querySelector('.product-card-price-old del');
            if (oldEl) {
                oldEl.textContent = sw.dataset.compare || '';
                if (oldEl.parentElement) oldEl.parentElement.style.display = sw.dataset.compare ? '' : 'none';
            }

            // Add-to-cart form: variant id + availability
            const form = this.card.querySelector('product-form');
            if (form) {
                const idInput = form.querySelector('input[name="id"]');
                if (idInput) idInput.value = sw.dataset.variant;
                const addBtn = form.querySelector('button[name="add"]');
                if (addBtn) {
                    const ok = sw.dataset.available === 'true';
                    addBtn.disabled = !ok;
                    const txt = addBtn.querySelector('.text');
                    if (txt && addBtn.dataset.addText && addBtn.dataset.soldoutText) {
                        txt.textContent = ok ? addBtn.dataset.addText : addBtn.dataset.soldoutText;
                    }
                }
            }
        }
    });
}
